import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React from 'react';
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Public Pages
import Index from "./pages/Index";
import ProjectOne from "./pages/ProjectOne";
import ProjectTwo from "./pages/ProjectTwo";
import ProjectThree from "./pages/ProjectThree";
import ProjectFour from "./pages/ProjectFour";
import ProjectFive from "./pages/ProjectFive";
import ProjectSix from "./pages/ProjectSix";
import ProjectSeven from "./pages/ProjectSeven";
import ProjectEight from "./pages/ProjectEight";
import Projects from "./pages/Projects";
import Careers from "./pages/Careers";
import CareersApply from "./pages/CareersApply";
import JobDetail from "./pages/JobDetail";
import NotFound from "./pages/NotFound";

// Admin Pages
import AdminLayout from "./components/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import JobsList from "./pages/admin/JobsList";
import JobForm from "./pages/admin/JobForm";
import AdminApplicants from "./pages/admin/AdminApplicants";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Index />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/project-one" element={<ProjectOne />} />
            <Route path="/project-two" element={<ProjectTwo />} />
            <Route path="/project-three" element={<ProjectThree />} />
            <Route path="/project-four" element={<ProjectFour />} />
            <Route path="/project-five" element={<ProjectFive />} />
            <Route path="/project-six" element={<ProjectSix />} />
            <Route path="/project-seven" element={<ProjectSeven />} />
            <Route path="/project-eight" element={<ProjectEight />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/job/:uniqueId" element={<JobDetail />} />
            <Route path="/careers/apply" element={<CareersApply />} />
            <Route path="/apply/:uniqueId" element={<CareersApply />} />

            {/* Admin Login (Public) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Admin Routes (Protected) */}
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="jobs" element={<JobsList />} />
              <Route path="jobs/create" element={<JobForm />} />
              <Route path="jobs/edit/:id" element={<JobForm />} />
              <Route path="applicants" element={<AdminApplicants />} />
            </Route>

            {/* 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

